import { formatPhoneNumber } from 'react-phone-number-input';
import {
    COMMUNICATION_LOG
} from '../../../../permissions';
import { timestampToHuman } from '../../../../services/formatting';
import {
    QueryGrid,
    QueryGridSelectMode,
} from '../../../shared/grid/queryGrid/queryGrid';

export const CommunicationLogList = (props) => {
    return (
        <QueryGrid
            queryParamPrefix=''
            singleResourceName='Log'
            pluralResourceName='Logs'
            nameFunction={(r) => r.sid}
            restEndpoint='/communications/logs'
            listUrl='/communications/logs'
            actions={[]}
            queryOnLoad={false}
            readPermissions={[COMMUNICATION_LOG.READ]}
            writePermissions={[COMMUNICATION_LOG.WRITE]}
            selectMode={QueryGridSelectMode.None}
            filters={[
                {
                    key: 'campaign',
                    label: 'Campaign',
                    type: 'select',
                    restEndpoint: '/communications/logs/campaigns',
                    allOption: true,
                    nameFunction: (v) => v.campaign,
                },
                {
                    key: 'type',
                    label: 'Type',
                    type: 'switch',
                    options: [
                        {
                            label: 'Any',
                            value: null,
                        },
                        {
                            label: 'Call',
                            value: 'Call',
                        },
                        {
                            label: 'Message',
                            value: 'Message',
                        },
                    ]
                },
                {
                    key: 'startTimeAfter',
                    label: 'After Date',
                    type: 'date',
                },
                {
                    key: 'startTimeBefore',
                    label: 'Before Date',
                    type: 'date',
                },
            ]}
            columns={{
                sid: {
                    label: 'Sid',
                    passOnClick: true,
                    size: '2fr',
                    formatFunction: (r) => (
                        <a href={r.link} target='_blank' rel='noreferrer'>
                            {r.sid}
                        </a>
                    ),
                },
                campaign: {
                    label: 'Campaign',
                },
                type: {
                    label: 'Type',
                },
                startTime: {
                    label: 'Time',
                    formatFunction: (r) => timestampToHuman(r?.startTime),
                },
                direction: {
                    label: 'Direction'
                },
                fromCallerId: {
                    label: 'From',
                    formatFunction: (r) => formatPhoneNumber(r.fromCallerId),
                },
                toCallerId: {
                    label: 'To',
                    formatFunction: (r) => formatPhoneNumber(r.toCallerId),
                },
                result: {
                    label: 'Result',
                },
            }}
            {...props}
        />
    );
};
